// app/javascript/scenes_editor/workflow_manager.js

function getAvailableList(controller) {
  return controller.element.querySelector("[data-workflow-available-list]")
}

function getUsedList(controller) {
  return controller.element.querySelector("[data-workflow-used-list]")
}

function getErrorBox(controller) {
  return controller.element.querySelector("[data-workflow-errors]")
}

function getEmptyUsedBox(controller) {
  return controller.element.querySelector("[data-workflow-empty-used]")
}

function getAllGroups(controller) {
  return Array.from(
    controller.element.querySelectorAll("[data-workflow-item-group]")
  )
}

function getAllUsedGroups(controller) {
  const usedList = getUsedList(controller)
  if (!usedList) return []

  return Array.from(
    usedList.querySelectorAll("[data-workflow-item-group]")
  )
}

function getAllAvailableGroups(controller) {
  const availableList = getAvailableList(controller)
  if (!availableList) return []

  return Array.from(
    availableList.querySelectorAll("[data-workflow-item-group]")
  )
}

function isGroupVisible(group) {
  if (!group) return false
  if (group.hasAttribute("hidden")) return false
  if (group.classList.contains("hidden")) return false
  if (group.style.display === "none") return false
  return true
}

function setGroupVisible(group, visible) {
  if (!group) return

  if (visible) {
    group.removeAttribute("hidden")
    group.classList.remove("hidden")
    group.style.display = ""
  } else {
    group.setAttribute("hidden", "hidden")
    group.classList.add("hidden")
    group.style.display = "none"
  }
}

function getUsedGroups(controller) {
  return getAllUsedGroups(controller).filter(isGroupVisible)
}

function getAvailableGroups(controller) {
  return getAllAvailableGroups(controller).filter(isGroupVisible)
}

function getIdentityFromGroup(group) {
  return {
    kind: group.dataset.workflowKind || null,
    pulse_tool_id: group.dataset.pulseToolId
      ? Number(group.dataset.pulseToolId)
      : null,
    hotspot_id: group.dataset.hotspotId
      ? Number(group.dataset.hotspotId)
      : null,
  }
}

function getIdentityKeyFromParts(kind, pulseToolId, hotspotId) {
  return [
    kind || "",
    pulseToolId != null ? String(pulseToolId) : "",
    hotspotId != null ? String(hotspotId) : "",
  ].join("::")
}

function getIdentityKey(group) {
  const identity = getIdentityFromGroup(group)
  return getIdentityKeyFromParts(
    identity.kind,
    identity.pulse_tool_id,
    identity.hotspot_id
  )
}

function getPositionValue(group) {
  const raw = group.dataset.workflowPositionValue
  const num = Number(raw)
  return Number.isFinite(num) && num > 0 ? num : 999999
}

function compareByInitialPosition(a, b) {
  return getPositionValue(a) - getPositionValue(b)
}

function getCheckbox(group) {
  return group.querySelector('input[type="checkbox"]')
}

function getSeverityInput(group) {
  return group.querySelector("[data-workflow-severity]")
}

function getMessageInput(group) {
  return group.querySelector("[data-workflow-message]")
}

function getOrderElement(group) {
  return group.querySelector("[data-workflow-order]")
}

function readSeverity(group) {
  const input = getSeverityInput(group)
  if (input) return (input.value || "optional").trim()
  return (group.dataset.workflowSeverityValue || "optional").trim()
}

function readMessage(group) {
  const input = getMessageInput(group)
  if (input) return (input.value || "").trim()
  return (group.dataset.workflowMessageValue || "").trim()
}

function syncGroupDataset(group) {
  group.dataset.workflowSeverityValue = readSeverity(group)
  group.dataset.workflowMessageValue = readMessage(group)
}

function setChecked(group, value) {
  const checkbox = getCheckbox(group)
  if (checkbox) checkbox.checked = !!value
}

function setDraggable(group, value) {
  if (value) {
    group.setAttribute("draggable", "true")
    group.classList.add("workflow-item--draggable")
  } else {
    group.removeAttribute("draggable")
    group.classList.remove("workflow-item--draggable")
  }
}

function isGroupUsed(controller, group) {
  const usedList = getUsedList(controller)
  return !!usedList && usedList.contains(group) && isGroupVisible(group)
}

function refreshOrderNumbers(controller) {
  getUsedGroups(controller).forEach((group, index) => {
    const orderEl = getOrderElement(group)
    if (orderEl) orderEl.textContent = String(index + 1)
  })
}

function refreshEmptyUsedState(controller) {
  const box = getEmptyUsedBox(controller)
  if (!box) return

  box.classList.toggle("hidden", getUsedGroups(controller).length > 0)
}

function clearWorkflowErrors(controller) {
  const box = getErrorBox(controller)
  if (!box) return

  box.classList.add("hidden")
  box.innerHTML = ""
}

function showWorkflowErrors(controller, errors) {
  const box = getErrorBox(controller)
  if (!box) return

  if (!errors || errors.length === 0) {
    clearWorkflowErrors(controller)
    return
  }

  box.innerHTML = `
    <div class="font-semibold mb-1">Controlla il workflow</div>
    <ul class="list-disc pl-5 space-y-1">
      ${errors.map((msg) => `<li>${msg}</li>`).join("")}
    </ul>
  `
  box.classList.remove("hidden")
}

function getTwinGroup(controller, sourceGroup) {
  if (!sourceGroup) return null

  const key = getIdentityKey(sourceGroup)
  const availableList = getAvailableList(controller)
  const usedList = getUsedList(controller)

  const inAvailable = !!availableList && availableList.contains(sourceGroup)
  const inUsed = !!usedList && usedList.contains(sourceGroup)

  if (inAvailable && usedList) {
    return getAllUsedGroups(controller).find((group) => getIdentityKey(group) === key) || null
  }

  if (inUsed && availableList) {
    return getAllAvailableGroups(controller).find((group) => getIdentityKey(group) === key) || null
  }

  return null
}

function copyValuesBetweenGroups(fromGroup, toGroup) {
  if (!fromGroup || !toGroup) return

  syncGroupDataset(fromGroup)

  const severity = readSeverity(fromGroup)
  const message = readMessage(fromGroup)

  toGroup.dataset.workflowSeverityValue = severity
  toGroup.dataset.workflowMessageValue = message

  const toSeverity = getSeverityInput(toGroup)
  if (toSeverity) toSeverity.value = severity

  const toMessage = getMessageInput(toGroup)
  if (toMessage) toMessage.value = message
}

function activateUsedGroup(controller, usedGroup) {
  if (!usedGroup) return

  const twin = getTwinGroup(controller, usedGroup)

  if (twin) {
    copyValuesBetweenGroups(twin, usedGroup)
    setChecked(twin, true)
    setDraggable(twin, false)
    setGroupVisible(twin, false)
  }

  setChecked(usedGroup, true)
  setDraggable(usedGroup, true)
  setGroupVisible(usedGroup, true)
}

function activateAvailableGroup(controller, availableGroup) {
  if (!availableGroup) return

  const twin = getTwinGroup(controller, availableGroup)

  if (twin) {
    copyValuesBetweenGroups(twin, availableGroup)
    setChecked(twin, false)
    setDraggable(twin, false)
    setGroupVisible(twin, false)
  }

  setChecked(availableGroup, false)
  setDraggable(availableGroup, false)
  setGroupVisible(availableGroup, true)
}

function moveIdentityToUsed(controller, sourceGroup) {
  const usedGroup = getUsedList(controller)?.contains(sourceGroup)
    ? sourceGroup
    : getTwinGroup(controller, sourceGroup)

  if (!usedGroup) return

  activateUsedGroup(controller, usedGroup)
  getUsedList(controller)?.appendChild(usedGroup)

  refreshOrderNumbers(controller)
  refreshEmptyUsedState(controller)
  clearWorkflowErrors(controller)
}

function moveIdentityToAvailable(controller, sourceGroup) {
  const availableGroup = getAvailableList(controller)?.contains(sourceGroup)
    ? sourceGroup
    : getTwinGroup(controller, sourceGroup)

  if (!availableGroup) return

  activateAvailableGroup(controller, availableGroup)
  getAvailableList(controller)?.appendChild(availableGroup)

  refreshOrderNumbers(controller)
  refreshEmptyUsedState(controller)
  clearWorkflowErrors(controller)
}

function bindToggleUse(controller, group) {
  const checkbox = getCheckbox(group)
  if (!checkbox) return

  const onChange = () => {
    if (checkbox.checked) {
      moveIdentityToUsed(controller, group)
    } else {
      moveIdentityToAvailable(controller, group)
    }
  }

  checkbox.addEventListener("change", onChange)
  controller._workflowHandlers.push(() =>
    checkbox.removeEventListener("change", onChange)
  )
}

function bindFieldSync(controller, group) {
  const severity = getSeverityInput(group)
  const message = getMessageInput(group)

  if (severity) {
    const onChange = () => {
      syncGroupDataset(group)
      const twin = getTwinGroup(controller, group)
      copyValuesBetweenGroups(group, twin)
      clearWorkflowErrors(controller)
    }

    severity.addEventListener("change", onChange)
    controller._workflowHandlers.push(() =>
      severity.removeEventListener("change", onChange)
    )
  }

  if (message) {
    const onInput = () => {
      syncGroupDataset(group)
      const twin = getTwinGroup(controller, group)
      copyValuesBetweenGroups(group, twin)
      clearWorkflowErrors(controller)
    }

    message.addEventListener("input", onInput)
    controller._workflowHandlers.push(() =>
      message.removeEventListener("input", onInput)
    )
  }
}

function bindGroupDrag(controller, group) {
  const onDragStart = (e) => {
    if (!isGroupUsed(controller, group)) {
      e.preventDefault()
      return
    }

    controller._draggedWorkflowGroup = group
    group.classList.add("opacity-60")
  }

  const onDragEnd = () => {
    group.classList.remove("opacity-60")
    controller._draggedWorkflowGroup = null
    refreshOrderNumbers(controller)
  }

  group.addEventListener("dragstart", onDragStart)
  group.addEventListener("dragend", onDragEnd)

  controller._workflowHandlers.push(() =>
    group.removeEventListener("dragstart", onDragStart)
  )
  controller._workflowHandlers.push(() =>
    group.removeEventListener("dragend", onDragEnd)
  )
}

function bindUsedListDrag(controller) {
  const usedList = getUsedList(controller)
  if (!usedList) return

  const onDragOver = (e) => {
    e.preventDefault()

    const dragged = controller._draggedWorkflowGroup
    if (!dragged || !isGroupVisible(dragged)) return

    const siblings = getUsedGroups(controller).filter((g) => g !== dragged)

    let inserted = false

    for (const sibling of siblings) {
      const rect = sibling.getBoundingClientRect()
      const middleY = rect.top + rect.height / 2

      if (e.clientY < middleY) {
        usedList.insertBefore(dragged, sibling)
        inserted = true
        break
      }
    }

    if (!inserted) {
      usedList.appendChild(dragged)
    }

    refreshOrderNumbers(controller)
  }

  const onDrop = (e) => {
    e.preventDefault()
    refreshOrderNumbers(controller)
    clearWorkflowErrors(controller)
  }

  usedList.addEventListener("dragover", onDragOver)
  usedList.addEventListener("drop", onDrop)

  controller._workflowHandlers.push(() =>
    usedList.removeEventListener("dragover", onDragOver)
  )
  controller._workflowHandlers.push(() =>
    usedList.removeEventListener("drop", onDrop)
  )
}

function sortInitialUsedGroups(controller) {
  const usedList = getUsedList(controller)
  if (!usedList) return

  const visibleGroups = getUsedGroups(controller).sort(compareByInitialPosition)
  visibleGroups.forEach((group) => usedList.appendChild(group))
}

function syncInitialPairs(controller) {
  const availableByKey = new Map(
    getAllAvailableGroups(controller).map((group) => [getIdentityKey(group), group])
  )

  getAllUsedGroups(controller).forEach((usedGroup) => {
    const key = getIdentityKey(usedGroup)
    const availableGroup = availableByKey.get(key)

    if (!availableGroup) return

    if (isGroupVisible(usedGroup)) {
      copyValuesBetweenGroups(usedGroup, availableGroup)
      setChecked(usedGroup, true)
      setChecked(availableGroup, true)
      setDraggable(usedGroup, true)
      setDraggable(availableGroup, false)
      setGroupVisible(usedGroup, true)
      setGroupVisible(availableGroup, false)
    } else {
      copyValuesBetweenGroups(availableGroup, usedGroup)
      setChecked(usedGroup, false)
      setChecked(availableGroup, false)
      setDraggable(usedGroup, false)
      setDraggable(availableGroup, false)
      setGroupVisible(usedGroup, false)
      setGroupVisible(availableGroup, true)
    }
  })
}

export function refreshWorkflowUI(controller) {
  const usedList = getUsedList(controller)
  const availableList = getAvailableList(controller)

  if (!usedList || !availableList) return

  syncInitialPairs(controller)
  refreshOrderNumbers(controller)
  refreshEmptyUsedState(controller)
}

export function collectWorkflowSteps(controller) {
  return getUsedGroups(controller).map((group, index) => {
    const identity = getIdentityFromGroup(group)

    return {
      kind: identity.kind,
      pulse_tool_id: identity.pulse_tool_id,
      hotspot_id: identity.hotspot_id,
      position: index + 1,
      severity: readSeverity(group),
      message: readMessage(group),
    }
  })
}

export function validateWorkflowSteps(controller, steps = null) {
  clearWorkflowErrors(controller)

  const currentSteps = steps || collectWorkflowSteps(controller)
  const errors = []

  if (!currentSteps.length) {
    errors.push("Seleziona almeno un elemento del workflow.")
  }

  currentSteps.forEach((step, index) => {
    if (!step.kind) {
      errors.push(`Lo step in posizione ${index + 1} non ha un tipo valido.`)
    }

    if (!["required", "warning", "optional"].includes(step.severity)) {
      errors.push(`Lo step in posizione ${index + 1} ha una severità non valida.`)
    }
  })

  if (errors.length > 0) {
    showWorkflowErrors(controller, [...new Set(errors)])
  }

  return {
    valid: errors.length === 0,
    errors: [...new Set(errors)],
    steps: currentSteps,
  }
}

export function initWorkflowEditor(controller) {
  controller._workflowHandlers = []
  controller._draggedWorkflowGroup = null

  getAllGroups(controller).forEach((group) => {
    syncGroupDataset(group)
    bindToggleUse(controller, group)
    bindFieldSync(controller, group)
    bindGroupDrag(controller, group)
  })

  bindUsedListDrag(controller)
  refreshWorkflowUI(controller)
  sortInitialUsedGroups(controller)
  refreshOrderNumbers(controller)
  refreshEmptyUsedState(controller)
  clearWorkflowErrors(controller)
}

export function destroyWorkflowEditor(controller) {
  ;(controller._workflowHandlers || []).forEach((unbind) => {
    try {
      unbind()
    } catch (_) {}
  })

  controller._workflowHandlers = []
  controller._draggedWorkflowGroup = null
}

export function buildWorkflowPayload(controller) {
  const validation = validateWorkflowSteps(controller)
  if (!validation.valid) return null

  return {
    workflow_steps: validation.steps.map((step) => ({
      kind: step.kind,
      pulse_tool_id: step.pulse_tool_id,
      hotspot_id: step.hotspot_id,
      position: step.position,
      severity: step.severity,
      message: step.message,
      config: {},
    })),
  }
}

export async function saveWorkflow(controller) {
  const payload = buildWorkflowPayload(controller)
  if (!payload) {
    return { ok: false, error: "Workflow non valido" }
  }

  const response = await fetch(controller.workflowUpdateUrlValue, {
    method: "PATCH",
    headers: {
      "Content-Type": "application/json",
      "X-CSRF-Token": controller.csrfTokenValue,
      Accept: "application/json",
    },
    body: JSON.stringify(payload),
  })

  const data = await response.json().catch(() => ({}))

  if (!response.ok) {
    return {
      ok: false,
      error: data?.error || "Errore durante il salvataggio del workflow",
    }
  }

  return { ok: true, data }
}